<template>
    <div>
        <v-card max-width="1030" class="mx-auto mt-5" id="busqueda">
            <v-card-title>
                <h4>SIAPA - Consulta de Expedientes</h4>
            </v-card-title>
            <v-card-text>
                <v-form @submit.prevent="buscar" id="busqueda-form">
                    <v-text-field type="text" label="Ingrese un valor para buscar"
                        hint="Nombres, Apellidos, Nro de Expediente o Asunto" v-model="valor" maxlength="100" />
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="info" @click="$router.push('/')">Volver</v-btn>
                <v-btn color="info" @click="buscar">Buscar</v-btn>
                <v-spacer></v-spacer>
                <span class="red--text" v-if="errorMessage">{{ errorMessage }}</span>
            </v-card-actions>
        </v-card>

        <v-card max-width="600" class="mx-auto" v-if="expedientes.length > 0">
            <v-toolbar color="light-blue" dark>

                <v-toolbar-title>Expedientes</v-toolbar-title>

                <v-spacer></v-spacer>

                <!-- <v-btn icon>
                    <v-icon>mdi-magnify</v-icon>
                </v-btn> -->

            </v-toolbar>

            <v-list subheader two-line>

                <v-list-item v-for="exp in expedientes" :key="exp.idRecepcion">
                    <v-list-item-avatar>
                        <v-icon class="green lighten-2" dark v-if="exp.estado == 'CERRADO'">
                            mdi-file-check
                        </v-icon>
                        <v-icon class="grey lighten-1" dark v-else>
                            mdi-file
                        </v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title> {{ exp.numeroExpediente }}/{{ exp.fechaExpediente | dateYear }}
                            {{ exp.recurrente }} </v-list-item-title>
                        <v-list-item-subtitle> {{ exp.referencia }}</v-list-item-subtitle>
                        <v-list-item-subtitle> {{ exp.fecha | dateTimeFormat }} {{ exp.departamento
                            }}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                        <ExpedienteDetalle :exp="exp" />
                    </v-list-item-action>
                </v-list-item>

                <v-divider inset></v-divider>

            </v-list>
        </v-card>

    </div>
</template>

<script>

import axios from "axios";
import moment from "moment";
import ExpedienteDetalle from "@/components/expedientes/ExpedienteDetalle.vue";

export default {
    data() {
        return {
            valor: "",
            mostrarBusqueda: false,
            errorMessage: "",
            expedientes: [],
        };
    },
    components: {
        ExpedienteDetalle
    },
    methods: {
        buscar() {

            this.errorMessage = "";
            this.expedientes = [];

            // if (!this.valor) {
            //     this.errorMessage = "Complete algun dato para buscar";
            //     return;
            // }

            axios
                .get("/expedientes?q="+this.valor)
                .then((response) => {

                    this.expedientes = response.data;

                })
                .catch((err) => {
                    console.log(err);
                });
        },

    },
    filters: {
        dateFormat(value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY");
            }
        },
        dateTimeFormat(value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY hh:mm");
            }
        },
        dateYear(value) {
            if (value) {
                return moment(String(value)).format("YYYY");
            }
        },
    },

};

</script>